import { useEffect } from "react";
import { Hero } from "../components/lendx/Hero";
import { TrustMarquee } from "../components/lendx/TrustMarquee";
import { LoanSolutions } from "../components/lendx/LoanSolutions";
import { EMICalculator } from "../components/lendx/EMICalculator";
import { EligibilityChecker } from "../components/lendx/EligibilityChecker";
import { PremiumServices } from "../components/lendx/PremiumServices";
import { WhyLendXSection, FundingJourney } from "../components/lendx/WhyJourney";
import { Industries } from "../components/lendx/Industries";
import { LenderNetwork } from "../components/lendx/LenderNetwork";
import { Testimonials } from "../components/lendx/Testimonials";
import { AboutSection } from "../components/lendx/AboutSection";
import { EnquiryForm } from "../components/lendx/EnquiryForm";
import { ContactSection } from "../components/lendx/ContactSection";
import { applySEO } from "../lib/scroll";

export default function Home() {
  useEffect(() => {
    applySEO(
      "LendX | Loan Advisory & Financial Solutions India — Your Finance. Simplified.",
      "LendX helps individuals and businesses navigate complex financing requirements — Home Loans, Loan Against Property, Business Loans, Working Capital, Corporate Finance and more."
    );
  }, []);

  return (
    <main data-testid="home-page">
      <Hero />
      <TrustMarquee />
      <LoanSolutions />
      <EMICalculator />
      <EligibilityChecker />
      <PremiumServices />
      <WhyLendXSection />
      <FundingJourney />
      <Industries />
      <LenderNetwork />
      <Testimonials />
      <AboutSection />
      <EnquiryForm />
      <ContactSection />
    </main>
  );
}
